/* global yaCounter70728685 */

import vars from '../helpers';

function clearText(text) {
	return text.toString().trim().replace(/\s+/g, ' ');
}

const $document = $(document);

export const start15SecTimeout = () => {
	clearTimeout($(window).data('timeout15Sec'));

	$(window).data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
};

start15SecTimeout();

export const virtualHit = (path) => {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	if (window.yaCounter70728685) {
		yaCounter70728685.hit(path);
	}
};

jQuery.scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, { nonInteraction: false });
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, { nonInteraction: false });
	},
});


$('.header__partner').on('click', () => {
	ga("send", "event", "client link", "logo header");
	ga("rbcspec.send", "event", "client link", "click");
});

$('.header__rbk').on('click', () => {

	ga("send", "event", "nav", "rbc logo");

});

//banners
export const checkBanner = () => {
	let $banners = $('.people');

	$banners.each((i, banner) => {
		let $banner = $(banner);

		let bannerTop = $banner.offset().top;
		let bannerHeight = $banner.height();

		let scrollTop = window.pageYOffset;
		let scrollTopHeight = scrollTop + window.innerHeight;

		if (scrollTopHeight >= bannerTop && bannerTop + bannerHeight >= scrollTop && !$banner.hasClass('isShown') && bannerTop !== 0) {
			$banner.addClass('isShown');

			let type = $banner.data('name');

			ga('send', 'event', 'main', 'screen progress view', `${type}`, { nonInteraction: true });
		}
	});
};

$(window).on('resize scroll', () => {
	checkBanner();
});

//links
const checkClientLink = (href) => {
	return (
		href.includes('ru.louisvuitton.com')
	);
};

$('.page__content a').on('click', (e) => {
	let $target = $(e.currentTarget);
	let href = $(e.currentTarget).attr('href');

	if (checkClientLink(href)) {
		ga('send', 'event', 'client link', 'text link', $target.text());
		ga('rbcspec.send', 'event', 'client link', 'click');
	} else {
		ga('send', 'event', 'text link', $target.text());
	}
});

//share footer
$('.share__item').on('click', (e) => {
	const name = e.currentTarget.dataset.social;

	ga("send", "event", "share", "project share", name);
});


$('.intro__card').on('click', (e) => {
	const $this = $(e.currentTarget);

	ga("send", "event", "main", "hero click", clearText($this.find('.intro__name').text()));
});


